(function () {
   /**
     * Resolve the shared cookie domain for TOMS properties.
     * @returns {string}
     */
    function getCookieDomain() {
      const { hostname } = window.location;

      if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        return hostname;
      }

      if (hostname.endsWith('.toms.com')) {
        return '.toms.com';
      }

      return hostname;
    }

    /**
     * Expire a cookie for a specific domain/path combination.
     * @param {string} name
     * @param {string} domain
     */
    function expireCookie(name, domain) {
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';
      const domainAttribute = domain ? `; domain=${domain}` : '';

      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${domainAttribute}; path=/; SameSite=Lax${secure}`;
    }

    /**
     * Remove duplicate copies of a cookie that may exist on the host and parent domains.
     * @param {string} name
     */
    function clearCookieVariants(name) {
      const { hostname } = window.location;

      expireCookie(name, '');
      expireCookie(name, hostname);

      if (hostname.endsWith('.toms.com')) {
        expireCookie(name, 'toms.com');
        expireCookie(name, '.toms.com');
      }
    }

    //set {"locale":"en-de"} cookie
    /**
     * Set cookie on TLD so it's shared across all subdomains
     * @param {string} name
     * @param {string} value
     * @param {number} days
     */
    function setTLDCookie(name, value, days = 365) {
      const domain = getCookieDomain();
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';

      clearCookieVariants('geo_redirected');
      clearCookieVariants(name);

      document.cookie = `${name}=${value}; expires=${expires}; domain=${domain}; path=/; SameSite=Lax${secure}`;
    }

    /**
     * Get cookie value by name and decode if it's the preferredLocaleH cookie
     * @param {string} name
     * @returns {string|null}
     */
    function getCookie(name) {
      const cookieValues = document.cookie
        .split('; ')
        .filter((cookie) => cookie.startsWith(`${name}=`))
        .map((cookie) => cookie.substring(name.length + 1))
        .filter(Boolean);

      if (cookieValues.length === 0) return null;

      const value = cookieValues[cookieValues.length - 1];
      if (!value) return null;
      
      // Decode preferredLocaleH cookie (base64-encoded JSON)
      if (name === 'preferredLocaleH') {
        try {
          const decoded = atob(value);
          const parsed = JSON.parse(decoded);
          return parsed.locale || null;
        } catch (e) {
          console.error('Failed to decode preferredLocaleH cookie:', e);
          return null;
        }
      }
      
      return value;
    }

    /**
     * Remove any leading locale-style path segments (e.g. /en-gb) so redirects
     * can safely append the current content path onto a new locale base URL.
     * @param {string} pathname
     * @returns {string}
     */
    function stripLocalePrefix(pathname) {
      if (!pathname || pathname === '/') return '/';

      const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
      const strippedPath = normalizedPath.replace(/^(\/[a-z]{2}-[a-z]{2})+?(?=\/|$)/i, '');

      return strippedPath || '/';
    }

    /**
     * Build a redirect URL using the target base and the current non-locale path.
     * @param {string} baseUrl
     * @returns {string}
     */
    function buildLocaleRedirectUrl(baseUrl) {
      if (!baseUrl) return '';

      const currentPath = stripLocalePrefix(window.location.pathname);
      const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

      return `${normalizedBaseUrl}${currentPath}${window.location.search}${window.location.hash}`;
    }

    /**
     * Set preferred locale cookie when user clicks a geo modal option
     * @param {string} locale - Locale code (e.g., 'en-us')
     * @param {string} url - Target URL to redirect to
     * @param {Event} event - Click event to prevent default
     * @param {boolean} isDistributor - Whether the redirect target is a distributor site
     */
    window.setGeoPreferredLocale = function(locale, url, event, isDistributor = false) {
      if (event) {
        event.preventDefault();
      }
      if (locale && !isDistributor) {
        const cookieValue = btoa(JSON.stringify({locale: locale}));
        setTLDCookie('preferredLocaleH', cookieValue);
      }
      if (url) {
        window.location.href = url;
      }
    };

    // Check for user-selected preferred locale (works on all pages)
    const preferredLocale = getCookie('preferredLocaleH');
    const currentLocale = window.currentShopLocale || '';

    // Skip redirect in theme editor, preview, or myshopify.com domains
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

    if (preferredLocale && currentLocale && currentLocale !== '') {
      // If user has a preferred locale and is not on that locale, redirect
      if (currentLocale !== preferredLocale) {
        /** @type {Record<string, string>} */
        const geoRedirectURLs = window.geoRedirectURLs || {};
        
        // Find the url with the matching locale
        if (geoRedirectURLs[preferredLocale]) {
          let targetUrl = geoRedirectURLs[preferredLocale];
          try {
            targetUrl = buildLocaleRedirectUrl(geoRedirectURLs[preferredLocale]);
          } catch {
            // Use as-is if URL parsing fails
          }

          window.location.href = targetUrl;
          return;
        } else {
          return;
        }
      }
    }
    
    // Get stores from window object (populated by Liquid template)
    const stores = window.geoLocationStores || {};
    const allowedCountries = Object.keys(stores);

    if (allowedCountries.length === 0) {
      console.warn('geo-location.js: No stores configured');
      return;
    }

    // Get user's country via Shopify's localization API
    if (!preferredLocale) {
    fetch('/browsing_context_suggestions.json')
      .then((response) => response.json())
      .then((data) => {
        const detectedCountry = data.detected_values.country.handle.toUpperCase();
        const currentDomain = window.location.hostname;
        const targetStore = stores[detectedCountry];
        
        // Only act if country is allowed, targetStore exists, and user is not already on the correct store and not in design mode
        if (allowedCountries.includes(detectedCountry) && targetStore && targetStore.url && !Shopify.designMode) {
            
            if (!targetStore.url.includes(currentDomain)) {
              /** @type {Record<string, string>} */
              const geoRedirectURLs = window.geoRedirectURLs || {};
              const targetLocale = Object.keys(geoRedirectURLs).find(locale => 
                locale.toLowerCase().endsWith('-' + detectedCountry.toLowerCase())
              );

              if (targetLocale) {
                // Encode as base64 JSON: {"locale":"en-de"}
                const cookieValue = btoa(JSON.stringify({locale: targetLocale}));
                setTLDCookie('preferredLocaleH', cookieValue);
                window.location.href = targetStore.url;
              }
            }
          }
        })
        .catch((err) => console.error('Geolocation detection failed:', err));
    }
})();
